import { AlertTriangle, X } from "lucide-react";

const ConfirmDeleteModal = ({ isOpen, title, isDeleting, onCancel, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 shrink-0 rounded-full bg-rose-100 dark:bg-rose-500/10 flex items-center justify-center text-rose-600 dark:text-rose-400">
            <AlertTriangle className="w-5 h-5" />
          </div>

          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">
              حذف گفتگو
            </h3>
            <p className="text-[13px] text-gray-500 dark:text-gray-400 mt-1 leading-6">
              گفتگوی «{title}» برای همیشه حذف می‌شود و قابل بازگشت نیست.
            </p>
          </div>

          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="w-7 h-7 shrink-0 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-zinc-800 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="px-4 py-2 rounded-xl text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-zinc-800 transition-colors disabled:opacity-50"
          >
            انصراف
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 rounded-xl text-sm font-medium text-white bg-rose-600 hover:bg-rose-700 shadow-sm shadow-rose-500/30 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isDeleting ? "در حال حذف..." : "حذف گفتگو"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;